export default __webpack_public_path__ + "static/media/semgrep-long.10ebe5bc.svg";